export const FORM_TYPE = {
  INITIAL_QUESTION: 'initial-question',
}
